import React from "react";
import "./Scrollingtxt.css";

const Scrollingtxt = () => {
  return (
    <div className="scroll-left">
      <p>
        శని త్రయోదశి పూజ. శని దోష పరిహారార్థం అమావాస్య. 13-06-2026.
        పౌర్ణమి.27-06-2026
      </p>
    </div>
  );
};

export default Scrollingtxt;
